<template>
	<div class="">
		<div
			v-for="link in contents?.content.link || []"
			:key="link._uid"
			class="text-left"
		>
			<v-storyblok-component :blok="link" />
		</div>
	</div>
</template>

<script setup lang="ts">
import {useStoryblokStory} from "@pkg/shared/composables/use-storyblok-story";

const {data: contents} = useStoryblokStory("global/terms-navigation");
</script>
